import Series from '../Series'

enum KnownSeries {
  QuickTips = 'quick tips',
  Essentials = 'essentials',
  GettingStarted = 'getting started',
}

export function isKnownSeries(series: Series, knownSeries: KnownSeries) {
  return series.title.toLowerCase().startsWith(knownSeries)
}

export function isQuickTips(series: Series) {
  return isKnownSeries(series, KnownSeries.QuickTips)
}

export default KnownSeries
